"use strict";

const warn = s => {
  console.warn('[react-gtm-module]', s);
};
module.exports = warn;